import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { CARDS } from './data';
import s from './index.module.scss';

export const InvestmentTypes = ({ data, className }) => {
  const { t } = useTranslation('calculator');
  return (
    <div className={classnames(s.wrapper, className)}>
      <h2 className="f-hero-h5">{t('inv_types.title')}</h2>
      <div className={s.cards}>
        {CARDS(t, data).map(card => (
          <div className={classnames(s.card, card.id)} key={card.id}>
            <div className={s.card_header}>
              <img
                src={card.icon}
                className={s.card_image}
                width={card.iconSize.width}
                height={card.iconSize.height}
                alt={card.label}
              />
              {card.label && (
                <div className={classnames(s.card_title, 'f-body-regular')}>
                  {card.label}
                </div>
              )}
            </div>
            <div className={s.card_info}>
              <div className={classnames(s.card_value, 'f-hero-h4')}>
                {card.value}
              </div>
              <div className={classnames(s.card_desc, 'f-small-regular')}>
                {card.description}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={classnames(s.note, 'f-small-regular')}>
        {t('inv_types.comparison_note')}
      </div>
    </div>
  );
};
